import { Navigate, Route, Routes } from "react-router-dom";

import { AdminLayout } from "@/layouts/AdminLayout";
import { AdminOnlyRoute } from "@/layouts/AdminOnlyRoute";
import { AuthRedirect } from "@/layouts/AuthRedirect";
import { GuestRoute } from "@/layouts/GuestRoute";
import { ProtectedRoute } from "@/layouts/ProtectedRoute";
import { SectionLayout } from "@/layouts/SectionLayout";
import { DashboardPage } from "@/pages/admin/DashboardPage";
import { FeedbacksPage } from "@/pages/admin/FeedbacksPage";
import { ArticleEditPage } from "@/pages/admin/articles/ArticleEditPage";
import { ArticlesLibraryPage } from "@/pages/admin/articles/ArticlesLibraryPage";
import {
  ArticlesRedactionPage,
  ArticlesStatisticsPage,
} from "@/pages/admin/articles/ArticlesSubPages";
import { EventEditPage } from "@/pages/admin/events/EventEditPage";
import { EventsLibraryPage } from "@/pages/admin/events/EventsLibraryPage";
import {
  EventsRedactionPage,
  EventsStatisticsPage,
} from "@/pages/admin/events/EventsSubPages";
import { PlaceEditPage } from "@/pages/admin/places/PlaceEditPage";
import { PlacesLibraryPage } from "@/pages/admin/places/PlacesLibraryPage";
import {
  PlacesRedactionPage,
  PlacesStatisticsPage,
} from "@/pages/admin/places/PlacesSubPages";
import { TaxonomyPage } from "@/pages/admin/TaxonomyPage";
import { LegalPage } from "@/pages/admin/LegalPage";
import { UsersPage } from "@/pages/admin/UsersPage";
import { UsersPreferencesPage } from "@/pages/admin/UsersPreferencesPage";
import { TeamPage } from "@/pages/admin/TeamPage";
import { AuthCallbackPage } from "@/pages/auth/AuthCallbackPage";
import { SetPasswordPage } from "@/pages/auth/SetPasswordPage";
import { LoginPage } from "@/pages/login/LoginPage";
import { OnboardingRoute } from "@/layouts/OnboardingRoute";
import { UsersSectionLayout } from "@/layouts/UsersSectionLayout";

import { NotificationsPage } from "@/pages/admin/NotificationsPage";

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<AuthRedirect />} />
      <Route element={<GuestRoute />}>
        <Route path="/login" element={<LoginPage />} />
      </Route>
      <Route path="/auth/callback/set-password" element={<AuthCallbackPage />} />
      <Route path="/auth/callback" element={<AuthCallbackPage />} />
      <Route element={<OnboardingRoute />}>
        <Route path="/set-password" element={<SetPasswordPage />} />
      </Route>

      <Route element={<ProtectedRoute />}>
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/taxonomy" element={<TaxonomyPage />} />

          <Route element={<AdminOnlyRoute />}>
            <Route path="/notifications" element={<NotificationsPage />} />
            <Route path="/team" element={<TeamPage />} />
            <Route path="/legal" element={<LegalPage />} />
            <Route path="/users" element={<UsersSectionLayout />}>
              <Route index element={<UsersPage />} />
              <Route path="preferences" element={<UsersPreferencesPage />} />
            </Route>
            <Route path="/feedbacks" element={<FeedbacksPage />} />
          </Route>

          <Route
            path="/articles"
            element={<SectionLayout basePath="/articles" />}
          >
            <Route index element={<Navigate to="library" replace />} />
            <Route path="library" element={<ArticlesLibraryPage />} />
            <Route path="redaction" element={<ArticlesRedactionPage />} />
            <Route path="redaction/:id" element={<ArticleEditPage />} />
            <Route path="statistics" element={<ArticlesStatisticsPage />} />
            <Route path=":id" element={<ArticleEditPage />} />
          </Route>

          <Route
            path="/events"
            element={<SectionLayout basePath="/events" />}
          >
            <Route index element={<Navigate to="library" replace />} />
            <Route path="library" element={<EventsLibraryPage />} />
            <Route path="redaction" element={<EventsRedactionPage />} />
            <Route path="redaction/:id" element={<EventEditPage />} />
            <Route path="statistics" element={<EventsStatisticsPage />} />
          </Route>

          <Route
            path="/places"
            element={<SectionLayout basePath="/places" />}
          >
            <Route index element={<Navigate to="library" replace />} />
            <Route path="library" element={<PlacesLibraryPage />} />
            <Route path="redaction" element={<PlacesRedactionPage />} />
            <Route path="redaction/:id" element={<PlaceEditPage />} />
            <Route path="statistics" element={<PlacesStatisticsPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="*" element={<AuthRedirect />} />
    </Routes>
  );
}
